// Text-Image block schema - Text + image layout section
export const textImageSchema = {
  type: 'text-image',
  label: 'Text + Image',
  description: 'Section with text content alongside an image',
  icon: 'LayoutPanelLeft',
  defaultContent: {
    heading: 'Section Heading',
    body: 'Add your content here. You can describe your services, share your story, or highlight important information.',
    image: '',
    layout: 'imageRight', // 'imageLeft' | 'imageRight' | 'imageTop'
    imageAlt: '',
    buttonText: '',
    buttonLink: '',
    headingSize: 'medium', // 'small' | 'medium' | 'large' | 'xlarge'
    imageSize: 'medium', // 'small' | 'medium' | 'large' | 'auto'
    style: {},
  },
  fields: [
    { name: 'heading', label: 'Heading', type: 'text', placeholder: 'Enter heading...' },
    {
      name: 'headingSize',
      label: 'Heading Size',
      type: 'select',
      options: [
        { value: 'small', label: 'Small' },
        { value: 'medium', label: 'Medium' },
        { value: 'large', label: 'Large' },
        { value: 'xlarge', label: 'Extra Large' },
      ],
    },
    { name: 'body', label: 'Body Text', type: 'richtext', placeholder: 'Enter body text...' },
    { name: 'image', label: 'Image', type: 'image' },
    { name: 'imageAlt', label: 'Image Alt Text', type: 'text', placeholder: 'Describe the image...' },
    {
      name: 'imageSize',
      label: 'Image Size',
      type: 'select',
      options: [
        { value: 'small', label: 'Small' },
        { value: 'medium', label: 'Medium' },
        { value: 'large', label: 'Large' },
        { value: 'auto', label: 'Auto (Natural)' },
      ],
    },
    {
      name: 'layout',
      label: 'Layout',
      type: 'select',
      options: [
        { value: 'imageLeft', label: 'Image Left' },
        { value: 'imageRight', label: 'Image Right' },
        { value: 'imageTop', label: 'Image Top' },
      ],
    },
    { name: 'buttonText', label: 'Button Text (optional)', type: 'text', placeholder: 'Learn More' },
    { name: 'buttonLink', label: 'Button Link', type: 'text', placeholder: 'https://...' },
  ],
};
